// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1tSs5","insightsList":"newBusinessInsightsMenu_insightsList__2Fu0d","active":"newBusinessInsightsMenu_active__1pIFE"};